<template>
  <div class="item">
    <span>请选择日期</span>
    <el-date-picker
      v-model="date"
      style="margin: 0 15px;"
      type="daterange"
      value-format="yyyy-MM-dd"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      :picker-options="pickerOptions"
    />
    <el-button type="primary" class="item_button" @click="theUpdata">更新</el-button>
    <div v-show="statistics_date.length>0" class="container" style="width:100%">
      <div id="main" />
    </div>
  </div>
</template>

<script>
import { SpWorkWechatSpCorpUserStatisticsList } from '@/api/employeeCorrespondencer.js'
export default {
  name: 'Datacalculate',
  props: ['newkeywords'],
  data() {
    return {
      date: [],
      list: [],
      add_user: [],
      del_user: [],
      statistics_date: [],
      pickerOptions: {
        disabledDate: (time) => {
          const endDate = new Date() // 当前日期
          endDate.setDate(endDate.getDate() + 10) // 结束日期为当前日期的基础上加 10 天

          return time.getTime() > endDate.getTime() // 禁用超过结束日期的日期
        }
      }
    }
  },

  created() {
  },
  mounted() {
    // console.log(this.newkeywords, 'newkeywords')
    this.datafliter()
  },
  methods: {
    closeEventadd() {
      this.date = []
      this.list = []
      this.add_user = []
      this.del_user = []
      this.statistics_date = []
    },
    // 时间转化
    formatDate(date) {
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    datafliter() {
      // 默认当前日期8天前，最后日期昨天
      const today = new Date()
      const firstDate = new Date(today)
      firstDate.setDate(today.getDate() - 8)
      const secondDate = new Date(today)
      secondDate.setDate(today.getDate() - 1)
      const firstDateString = this.formatDate(firstDate)
      const secondDateString = this.formatDate(secondDate)
      this.date = [firstDateString, secondDateString]
    },
    async theUpdata() {
      console.log(this.date)
      const data = {
        employee_no: this.newkeywords[0].employee_no,
        // employee_no: 'SPUSO2023060815542740891085',
        begin: this.date[0],
        end: this.date[1]
      }
      console.log(1211212)
      const res = await SpWorkWechatSpCorpUserStatisticsList(data)
      if (res.data === null) {
        this.list = []
        this.add_user = []
        this.del_user = []
        this.statistics_date = []
        this.$message({
          message: '请求内容无数据,请重新输入',
          type: 'success'
        })
      }
      if (res.data || res.data.length > 0) {
        this.add_user = res.data.map(e => e.add_user).reverse()
        this.del_user = res.data.map(e => e.del_user).reverse()
        this.statistics_date = res.data.map(e => e.statistics_date.slice(5)).reverse()

        this.list = res.data
        console.log('this.list :', this.list)
        this.echartsdemo()
        this.$message({
          message: '更新成功',
          type: 'success'
        })
      }
    },
    echartsdemo() {
      var chartDom = document.getElementById('main')
      var myChart = this.$echarts.init(chartDom)
      var option
      option = {
        xAxis: {
          type: 'category',
          data: this.statistics_date
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '新增',
            data: this.add_user,
            type: 'line'
          },
          {
            name: '删除',
            type: 'line',
            data: this.del_user
          }
        ],
        tooltip: {
          trigger: 'axis', // 悬停在坐标轴上时触发 tooltip
          axisPointer: {
            type: 'line' // 设置指示器类型为线形
          }
        }
      }

      option && myChart.setOption(option)
      this.$nextTick(() => {
        window.addEventListener('resize', function() {
          myChart.resize()
        })
      })
    }
  }
}
</script>

<style scoped>
.item{
  font-size: 1rem;
  margin-bottom: 105px;
}

#main {
  width: 500px;
  height: 350px;
}

@media screen and (max-width: 768px) {
  #chart-container {
    height: 300px;
  }
}
</style>
